import { AxiosPromise } from "axios";

import api from "../../config/api-supplier-config";

export function getUserPopulateData(): AxiosPromise {
  return api.get("v1/auth");
}

export function getDailyProcessLog(): AxiosPromise {
  return api.get("v1/dailyProcessLog");
}

export default {
  getUserPopulateData,
  getDailyProcessLog,
};
